
import { defineComponent, watch, ref } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "siaran-modal",
  components: {},
  props: { file: String },

  setup(props) {
    // const source = ref(process.env.VUE_APP_UPLOAD_FILE);
    watch(props, () => {
      console.log("Props", props.file);
    });

    return {
      //source,
    };
  },
});
